const permissionAccessConfig = {
  PERMISSIONS: {
    EDIT_PERMISSIONS: 'EditPermissions',
  },
  USERS: {
    EDIT_USER: 'EditUser',
  },
  LOCATION: {
    EDIT_LOCATION: 'EditLocation',
  },
  TAGS: {
    EDIT_TAGS: 'EditTags',
  },
  BUSINESS_UNIT: {
    EDIT_BUSINESS_UNIT: 'EditBusinessUnit',
  },
  DIVISION: {
    EDIT_DIVISION: 'EditDivision',
  },
  TEMPLATE: {
    EDIT_TEMPLATE: 'EditTemplate',
  },
  SCHEDULE: {
    EDIT_SCHEDULE: 'EditSchedule',
  },
  QUESTION: {
    EDIT_QUESTION: 'EditQuestion',
  },
  CATEGORY: {
    EDIT_CATEGORY: 'EditCategory',
  },
  TEST_AUDIT: {
    EDIT_TEST_AUDIT: 'EditTestAudit',
    PERFORM_TEST_AUDIT: 'PerformTestAudit',
    CLOSE_TEST_AUDIT: 'CloseTestAudit',
    REOPEN_TEST_AUDIT: 'ReopenTestAudit',
  },
  SITUATION_AUDIT: {
    EDIT_SITUATION_AUDIT: 'EditSituationAudit',
    PERFORM_SITUATION_AUDIT: 'PerformSituationAudit',
    CLOSE_SITUATION_AUDIT: 'CloseSituationAudit',
    REOPEN_SITUATION_AUDIT: 'ReopenSituationAudit',
  },
  PROGRESS_AUDIT: {
    EDIT_PROGRESS_AUDIT: 'EditProgressAudit',
    PERFORM_PROGRESS_AUDIT: 'PerformProgressAudit',
    CLOSE_PROGRESS_AUDIT: 'CloseProgressAudit',
    REOPEN_PROGRESS_AUDIT: 'ReopenProgressAudit',
  },
  CALIBRATION_AUDIT: {
    EDIT_CALIBRATION_AUDIT: 'EditCalibrationAudit',
    PERFORM_CALIBRATION_AUDIT: 'PerformCalibrationAudit',
    CLOSE_CALIBRATION_AUDIT: 'CloseCalibrationAudit',
    REOPEN_CALIBRATION_AUDIT: 'ReopenCalibrationAudit',
  },
  MPA_AUDIT: {
    EDIT_MPA_AUDIT: 'EditMpaAudit',
    PERFORM_MPA_AUDIT: 'PerformMpaAudit',
    CLOSE_MPA_AUDIT: 'CloseMpaAudit',
    REOPEN_MPA_AUDIT: 'ReopenMpaAudit',
  },
  TASK: {
    EDIT_TASK: 'EditTask',
    PERFORM_TASK: 'PerformTask',
    CANCEL_TASK: 'CancelTask',
    CHANGE_ASSIGNEE: 'ChangeTaskAssignee',
    REOPEN_TASK: 'ReopenTask',
  },
  REPORTS: {
    EDIT_REPORTS: 'EditReports',
  },
  FEEDBACK: {
    EXPORT_FEEDBACK: 'ExportFeedback',
  },
} as const;

const permissionsArray = Object.values(permissionAccessConfig).flatMap((category) =>
  Object.values(category).map((permission) => {
    return permission;
  }),
);
type Permission = (typeof permissionsArray)[number];
export default permissionAccessConfig;
export { permissionsArray, type Permission };
